import { render, staticRenderFns } from "./CollegeName.vue?vue&type=template&id=06a599b6&"
import script from "./CollegeName.vue?vue&type=script&lang=ts&"
export * from "./CollegeName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports